<template>
    <div class="birthday-page">
      <h1>Happy 29th Birthday, Will! 🎉</h1>
  
      <div class="card-section">
        <p class="tagline">Hawks Fanatic. Country Music Junkie. Arbeiter of Law.</p>
      </div>
  
      <div class="card-section highlight">
        <h2>🏒 For the Love of Hockey</h2>
        <p>
          From the first puck drop to overtime shootouts, you've lived and breathed Blackhawks hockey.
          Here's hoping next year is full of wins — both on the ice and in life.
        </p>
      </div>
  
      <div class="card-section">
        <h2>⚖️ One Year In the Books</h2>
        <p>
          It’s almost been a full year in law, and you’ve already proven you’ve got the grit and brains to thrive
          (Even if the evidence ain't the best). I know this is just the beginning of something huge.
        </p>
      </div>
  
      <div class="card-section highlight">
        <h2>🎶 Country Roads, Legal Codes</h2>
        <p>
          Whether it's blasting Post Malone or closing arguments, you always know how to set the tone. 
          Just don’t try quoting *both* in court, though if anyone could find a way to, its you.
        </p>
      </div>
  
      <div class="card-section">
        <h2>🥃 Here's to You</h2>
        <p>
          Wishing you a year of laughter, success, and plenty of whiskey with friends.
          Love you, bro — proud of everything you’ve done and everything you're gonna do.
        </p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "BirthdayWill29",
  };
  </script>
  
  <style scoped>
  .birthday-page {
    font-family: "Segoe UI", Arial, sans-serif;
    line-height: 1.6;
    color: #ffffff;
    background-color: #181825;
    max-width: 800px;
    margin: 0 auto;
    padding: 30px 20px;
    border-radius: 8px;
    text-align: center;
  }
  
  h1 {
    color: #dfa8cd;
    font-size: 2.2rem;
    margin-bottom: 20px;
  }
  
  h2 {
    color: #dfa8cd;
    margin-bottom: 10px;
    font-size: 1.5rem;
  }
  
  .card-section {
    background-color: #362e5f;
    border-radius: 10px;
    padding: 20px;
    margin: 20px 0;
  }
  
  .card-section.highlight {
    background-color: #4b3e80;
  }
  
  .tagline {
    font-style: italic;
    font-size: 1.1rem;
    color: #d1c1e0;
  }
  </style>
  